/**
 * deptRowFilter.ts — assess-screen department filter, at table-row granularity.
 *
 * The generic review filter hides whole top-level blocks and only DIMS the
 * sub-fragments inside a surviving block. For a table that means: as soon as one
 * row is stamped for the selected department, the ENTIRE table renders (the other
 * rows merely dimmed). Assessors found that noisy — they want just the relevant
 * rows.
 *
 * This transform drops, from every table, the rows that carry no stamp for a
 * selected department. The row mechanics (header rows kept, rowspan groups kept
 * whole, top-level identity preserved) live in `tableRowFilter.ts`.
 */

import { HastNode } from "./hast";
import { filterTableRowsByKey } from "./tableRowFilter";

/**
 * Remove table rows not stamped for a selected department (header rows kept).
 * With no departments selected (the "all" state) the tree is returned unchanged.
 */
export function filterTableRowsByDept(
    nodes: HastNode[],
    deptIdByKey: Record<string, number>,
    selectedDeptIds: number[],
): HastNode[] {
    if (selectedDeptIds.length === 0) return nodes;
    const selected = new Set(selectedDeptIds);
    return filterTableRowsByKey(nodes, (k) => selected.has(deptIdByKey[k]));
}
